import { render, staticRenderFns } from "./SpecialismsSection.vue?vue&type=template&id=0cc65921&"
import script from "./SpecialismsSection.vue?vue&type=script&lang=js&"
export * from "./SpecialismsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports